import axios from '~/data/http/axios'

export function fetchTier() {
    return function (dispatch) {
        axios
            .get('/accountMaster/tier')
            .then((res) => {
                dispatch(updateTier(res.data.Tier))
            })
            .catch(() => {})
        }
}

export function updateTier(tier) {
    return function (dispatch) {
        dispatch({ type: 'CHANGE_TIER', payload: tier })
    }
}

export function changePanels(panels) {
    return function (dispatch) {
        dispatch({ type: 'CHANGE_PANELS', payload: panels })
    }
}

export function changeChart(chart) {
    return function (dispatch) {
        dispatch({ type: 'CHANGE_CHART', payload: chart })
    }
}

export function changeTable(table) {
    return function (dispatch) {
        dispatch({ type: 'CHANGE_TABLE', payload: table })
    }
}

export function updateAccountProgress() {
    return function (dispatch) {
        axios
            .get('/accountMaster/onboarding')
            .then(function (response) {
                dispatch({ type: 'CHANGE_ACCOUNT_PROGRESS', payload: response.data })
            })
            .catch(() => {
                dispatch({ type: 'CHANGE_ACCOUNT_PROGRESS', payload: {} })
            })
    }
}
